import { render, staticRenderFns } from "./store-grade.vue?vue&type=template&id=24e7bb53&scoped=true"
import script from "./store-grade.vue?vue&type=script&lang=js"
export * from "./store-grade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e7bb53",
  null
  
)

export default component.exports